// router.js 或 router/index.js
import {createRouter, createWebHashHistory} from 'vue-router';

const routes = [
    // 请提供路由配置，特别是 /home 路径的配置
    {
        path: '/',
        name: 'Home',
        component: () => import('./components/Home.vue') // 或其他组件路径
    },
    {
        path: '/about',
        name: 'aboutUs',
        component: () => import('./components/AboutUs.vue') // 或其他组件路径
    },

    {
        path: '/list/:categoryId',
        name: 'PdtList',
        component: () => import('./components/PdtList.vue') // 或其他组件路径
    },

    {
        path: '/contact',
        name: 'contactUs',
        component: () => import('./components/ContactUs.vue') // 或其他组件路径
    },
    {
        path: '/desc',
        name: 'Desc',
        component: () => import('./components/PdtDesc.vue') // 或其他组件路径
    },
    {
        path: '/xunpan',
        name: 'Xunpan',
        component: () => import('./components/XunPan.vue') // 或其他组件路径
    },
    {
        path: '/led',
        name: 'Led',
        component: () => import('./components/LEDTest.vue') // 或其他组件路径
    },
    {
        path: '/TestPdtDesc',
        name: 'TestPdtDesc',
        component: () => import('./components/TestPdtDesc.vue') // 或其他组件路径
    },
];


const router = createRouter({
/*    history: createWebHistory(),*/
    history: createWebHashHistory(),
    routes
});

export default router;
